import { Injectable } from '@angular/core';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { TaskCenterNotificationPushService } from './TaskCenterNotificationPushService';

@Injectable({ providedIn: 'root' })
export class TaskCenterNotificationService {
  private pendingCountSubject = new BehaviorSubject<number>(0);
  pendingCount$ = this.pendingCountSubject.asObservable();
  private actionRequiredCountSubject = new BehaviorSubject<number>(0);
  actionRequiredCount$ = this.actionRequiredCountSubject.asObservable();
  private collectionCaseCountSubject = new BehaviorSubject<number>(0);
  collectionCaseCount$ = this.collectionCaseCountSubject.asObservable();
  // Documents contribute presence to the menu; their separate tab count remains hidden.
  readonly documentImportCount$ = of(0);
  private connection: Subscription;

  constructor(private push: TaskCenterNotificationPushService) { }

  refreshPendingCount(): void {
    if (this.connection && !this.connection.closed) {
      this.push.requestRefresh();
      return;
    }
    this.connection = this.push.watch().subscribe({
      next: state => {
        const actions = this.normalizeCount(state.ActionRequiredCount);
        const cases = this.normalizeCount(state.CollectionCaseCount);
        this.actionRequiredCountSubject.next(actions);
        this.collectionCaseCountSubject.next(cases);
        this.pendingCountSubject.next([
          state.PayoutCount, state.CertificateCount, cases, state.DocumentCount
        ].reduce((sum, count) => sum + this.normalizeCount(count), 0));
      },
      error: error => {
        if (error.status === 401 || error.status === 403) this.reset();
      }
    });
  }

  reset(): void {
    this.connection?.unsubscribe();
    this.pendingCountSubject.next(0);
    this.actionRequiredCountSubject.next(0);
    this.collectionCaseCountSubject.next(0);
  }

  private normalizeCount(value: number): number {
    return typeof value === 'number' && isFinite(value) && value >= 0 ? Math.floor(value) : 0;
  }
}
